"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Design___StyledSvg",
  componentId: "sc-18oqwpx-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Design(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M369.974 280c-14.8 0-28.5 4.3-40.42 11.32l-37.16-37.18-28.28 28.28 37.18 37.16c-7.02 11.92-11.32 25.6-11.32 40.42 0 44.14 35.82 80 80 80 14.8 0 28.5-4.3 40.4-11.32l-54.54-54.54 28.28-28.28 54.54 54.54c7.02-11.9 11.32-25.6 11.32-40.4 0-44.2-35.82-80-80-80m-240-80c14.8 0 28.5-4.3 40.4-11.32l37.18 37.18 28.28-28.28-37.18-37.18c7.02-11.9 11.32-25.6 11.32-40.4 0-44.2-35.82-80-80-80-14.8 0-28.5 4.3-40.42 11.32l54.56 54.54-28.28 28.28-54.54-54.56c-7.02 11.92-11.32 25.6-11.32 40.42 0 44.14 35.82 80 80 80"
  }), _react["default"].createElement("path", {
    d: "M218.258 300l155.86-155.86 15.86 15.86 60-80-40-40-80 60 15.86 15.86-155.86 155.86-45.86-45.86-28.28 28.28 25.86 25.86-85.86 85.86c-7.82 7.82-7.82 20.46 0 28.28l40 40c7.8 7.82 20.46 7.82 28.28 0l85.86-85.86 25.86 25.86 28.28-28.28-45.86-45.86z"
  })));
}

var _default = Design;
exports["default"] = _default;